import { render } from "./cinemar.vue?vue&type=template&id=3f622d7e"
import script from "./cinemar.vue?vue&type=script&lang=js"
export * from "./cinemar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__